import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * SSO Start Page for Quick Canvass
 * 
 * Initiates OIDC login flow by:
 * 1. Calling /api/quick-canvass/sso/start
 * 2. Redirecting to the returned authorize URL
 */
export const QCSSOStartPage = () => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('return_to') || '/quick-canvass';
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initiateSSO = async () => {
      try {
        const response = await fetch(
          `${API_URL}/api/quick-canvass/sso/start?return_to=${encodeURIComponent(returnTo)}`
        );
        
        if (!response.ok) {
          throw new Error(`SSO start failed: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.url) {
          // Redirect to GETGRIDGATE authorize endpoint
          window.location.href = data.url;
        } else {
          setError('No redirect URL received');
          setLoading(false);
        }
      } catch (err) {
        console.error('SSO initiation error:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    initiateSSO();
  }, [returnTo]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Sign-In Error</h2>
          <p className="text-slate-600 mb-4">{error}</p>
          <a 
            href="/login" 
            className="inline-block px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
          >
            Return to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-slate-900 mb-2">Signing you in...</h2>
        <p className="text-slate-600">Redirecting to GETGRIDGATE for authentication</p>
      </div>
    </div>
  );
};

export default QCSSOStartPage;
